import { render, staticRenderFns } from "./addEventMenu.vue?vue&type=template&id=454cdf30&"
import script from "./addEventMenu.vue?vue&type=script&lang=js&"
export * from "./addEventMenu.vue?vue&type=script&lang=js&"
import style0 from "./addEventMenu.vue?vue&type=style&index=0&id=454cdf30&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports